import {mapMutations} from "vuex";
import router from "@/router";

const DownloadActionMixins = {
    methods: {
        ...mapMutations(["createDownloadRequest"]),
        downloadActionMixin(version_id: number, title: string) {
            this.createDownloadRequest({
                version_id: version_id,
                title: title
            })

            router.push({name: 'download'})
        }
    }
}

export default DownloadActionMixins